import React from "react";
import Checkbox from "material-ui/Checkbox";
import { CircleIcons, muiLabelStyle } from "ui-components";

import {
  AppendixTipWrapper,
  AppendixTipContent,
  AppendixTipText
} from "./styled";

const AppendixTip = ({ children, tipInfo, isChecked, onClick }) => {
  const { EmptyCircle, CheckedCircle } = CircleIcons;

  return (
    <AppendixTipWrapper>
      <AppendixTipContent onClick={onClick}>
        <Checkbox
          checked={isChecked}
          disableTouchRipple
          labelStyle={muiLabelStyle}
          style={{ width: "initial" }}
          iconStyle={{ height: "18px", marginRight: "5px" }}
          uncheckedIcon={<EmptyCircle />}
          checkedIcon={<CheckedCircle />}
        />
        <AppendixTipText size="5" isBold={isChecked}>
          {children}
        </AppendixTipText>
      </AppendixTipContent>
    </AppendixTipWrapper>
  );
};

export default AppendixTip;



// WEBPACK FOOTER //
// ./src/common/components/AppendixDialog/AppendixTip.jsx